export const MEMS_URL = "http://127.0.0.1:8000/api/mems"
export const UPLOAD_URL = "http://localhost:3001/upload";

